import styled, { useTheme, css } from 'styled-components';
import uniqueId from 'lodash/uniqueId';
import { useIntl } from 'react-intl';
import Icon from '../../atoms/Icon';
import Container from '~/grid/Container';
import EditButton from '../../atoms/EditButton';
import CTA from '../../atoms/CTA';

/**
 * @param {FooterType} props
 * @returns {string}
 */
const getMobileSwitch = (props) => props.theme.footer.mobileSwitch;

export const IconStyled = styled(Icon)`
  path {
    fill: ${(props) => props.theme.color.white500};
  }
  margin-right: 17px;
  display: inline;
`;

const FooterNote = styled(Container)`
  display: block;
  font-size: 0.7em;
  color: #fff;
  margin: 0px auto;
  padding-bottom: 20px;
  width: 100%;

  @media (${(props) => getMobileSwitch(props)}) {
    margin-bottom: 20px;
  }
`;

const FooterStyled = styled.div`
  position: relative;
  width: 100%;
  background: ${(props) => props.theme.color.deepHumanBlue100};
  display: inline-block;
  padding: 20px 0px;
  @media (${(props) => getMobileSwitch(props)}) {
    padding: ${(props) =>
      props.theme.footer.linksInGrid ? '0px' : '30px 0px 10px'};
  }

  a {
    font-size: ${(props) => props.theme.footer.fontSize}px;
    background-color: transparent;
    color: ${(props) => props.theme.color.white500};

    @media (${(props) => getMobileSwitch(props)}) {
      font-size: inherit;
    }
  }
`;

const FooterContainer = styled(Container)`
  display: ${(props) => (props.theme.footer.linksInGrid ? 'grid' : 'flex')};
  grid-template-columns: max-content ${(props) =>
      props.theme.footer.linksInGrid ? '1fr' : 'auto'};
  align-items: center;
  justify-content: flex-start;
  @media (${(props) => getMobileSwitch(props)}) {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
  }
`;

const FooterCopyright = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  margin-bottom: 0px;
  justify-content: flex-start;
  @media (${(props) => getMobileSwitch(props)}) {
    align-items: flex-start;
    margin-bottom: 55px;
  }
`;

const FooterLinks = styled.div`
  ${(props) =>
    props.theme.footer.linksInGrid
      ? css`
          display: grid;
          grid-template-columns: repeat(3, 1fr);

          a {
            padding-left: 25%;
          }

          @media (${(props) => props.theme.footer.mobileSwitch}) {
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
            a {
              padding-left: 0px;
            }
          }
        `
      : css`
          display: flex;
          justify-content: flex-end;
          flex-direction: row;
          gap: 20px;
          a {
            margin-left: ${props.theme.footer.linksMargin}px;
          }
          @media (${(props) => props.theme.footer.mobileSwitch}) {
            justify-content: flex-start;
            flex-direction: column;
            margin-bottom: 20px;
            a {
              margin-left: 0px;
            }
          }
        `}
`;

const EditButtonStyled = styled(EditButton)`
  position: absolute;
  top: 0;
  left: 0;
`;

/**
 * @param {FooterSmallProps} props
 * @returns {React.ReactElement} The rendered component
 */
const FooterSmall = ({ className, copyright, links, editMode }) => {
  const theme = useTheme();
  const intl = useIntl();

  return (
    <FooterStyled className={className} data-id="footer">
      {editMode && (
        <EditButtonStyled
          text={editMode.text}
          href={editMode.link}
          onHover={() => {}}
        />
      )}
      {theme.footer.genderNotice && (
        <FooterNote data-id="footer-note">
          {intl.formatMessage({
            id: `footer.gender.notice`,
          })}
        </FooterNote>
      )}
      <FooterContainer data-id="footer-container">
        <FooterCopyright data-id="footer-copyright">
          <CTA {...copyright} skin="NAVIGATION_FOOTER" />
        </FooterCopyright>
        <FooterLinks data-id="footer-links">
          {links.map((linkProps) => {
            return (
              <CTA
                skin="NAVIGATION_FOOTER"
                {...linkProps}
                key={uniqueId('footer-')}
              />
            );
          })}
          <CTA
            skin="NAVIGATION_FOOTER"
            href={'#'}
            handleBtnClick={() => {
              if (typeof window !== 'undefined' && window.OneTrust) {
                window.OneTrust.ToggleInfoDisplay();
              }
            }}
            text={intl.formatMessage({
              id: `cookie.settings.link.label`,
            })}
            key={uniqueId('footer-')}
          />
        </FooterLinks>
      </FooterContainer>
    </FooterStyled>
  );
};
export default FooterSmall;
